import { SAVE_LIGIN_MSG, INIT_LOGIN_MSH } from './actions';

const initialState = {
  easylogin: false, // 简易登录，未统一登录
};

export default function easyLoginQueryReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_LIGIN_MSG:
      return Object.assign({}, state, action.data);
    case INIT_LOGIN_MSH:
      if (action.data) {
        return Object.assign({}, state, action.data);
      } else {
        return Object.assign({}, state, { easylogin: false });
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/easyLogin/modules/easyLogin.js